// 供销商小店商品列表
<template>
  <div class="display-goods-list" v-show="!hideGoodsList">
    <GoodsFilter
      ref="goodsFilter"
      :supplierCompanyId="supplierCompanyId"
      @search="search"
      @updateFilterParams="updateFilterParams"
    />

    <Search
      ref="search"
      @search="search"
      :supplierCompanyId="supplierCompanyId"
      :newPutTime="filterParams.newPutTime"
      :list="list"
    />
    <div class="sticky">
      <div class="table-btns-wrap">
        <el-checkbox
          v-model="allSelected"
          class="mgr12"
        >
          本页全选
        </el-checkbox>
        <template v-if="!readonly">
          <el-button
            type="primary"
            @click="groupBulkShelves"
            :disabled="!selectedGoods.length"
            plain
          >
            组合铺货
          </el-button>
          <el-button
            type="primary"
            @click="topBtnsClick"
            :disabled="!selectedGoods.length"
            plain
          >
            批量铺货
          </el-button>
          <el-button
            type="primary"
            @click="batchAddDistribution"
            plain
            :disabled="!selectedGoods.length"
          >
            加入分销商品
          </el-button>
        </template>
      </div>
      <Sorter
        ref="sorter"
        @search="search"
        :disabled="list.length === 0"
        :list="list"
      />
    </div>
    <GoodsList
      ref="goodList"
      :list="list"
      :supplierCompanyId="supplierCompanyId"
      :amountPrecision="amountPrecision"
      @join="row => rowClick('join', row)"
      @shelves="row => rowClick('shelves', row)"
      @update="row => rowClick('update', row)"
      @updateSelectedGoods="updateSelectedGoods"
      :isInCooperation="isInCooperation"
      :readonly="readonly"
    />
    <el-pagination
      :style="{ padding: '8px 16px', textAlign: 'right' }"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.pageNo"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    >
    </el-pagination>
    <!-- 采购车 -->
    <div v-if="!readonly" class="shop-cart" @click="toShoppingCart">
      <div>
        <el-image :src="shoppingCartImg" class="image-cart"></el-image>
        <div v-if="cartNumber" class="num">{{cartNumber}}</div>
      </div>
      <div class="text">采购车</div>
    </div>
    <!-- 商品资料编辑 -->
    <EditDialog ref="editDialog" @search="formUpdated => formUpdated ? fetchList() : null" />
    <BulkShelvesDialog
      :openEdit="openEditDialog"
      :closeEdit="closeEditDialog"
      :smallShopItem = "true"
      @search="fetchList"
      ref="bulkShelvesDialog"
    />
    <BulkShelvesResults
      ref="bulkShelvesResults"
      @search="search"
      :publishSpeedResult="publishResult"
      :percentage="publishPercenttage"
      pageId="d_display"
    />
    <!-- 组合铺货 -->
    <GroupBulkShelvesDialog
      @search="search"
      ref="groupBulkShelvesDialog"
      mode="distributor"
      from="supplierShop"
      :supplierCompanyId="supplierCompanyId"
    />
    <!-- 转为自发商品弹窗 -->
    <ImportSupplierItem ref="importSupplierItem" />
    <!-- 导入 -->
    <DownloadProgress ref="progressDialog" :isJoin="isJoin" @close="progressClose">
      <template slot="title">
        <span class="down-title">{{ this.progressTitle }}</span>
      </template>
    </DownloadProgress>
    <!-- 导入结果信息弹窗 -->
    <DownloadResult
      :visible.sync="resultVisible"
      :resultData="resultData"
      @search="search"
    >
      <template v-slot:title>
        <span class="down-title">商品导入完成</span>
      </template>
    </DownloadResult>
     <CheckboxOuterId ref="checkboxOuterId" @join="(params,type,row,shelvesType)=> fetch_importSupplierItem(params,type,row,shelvesType)"/>
    <ErrorInfo ref="errorInfo" />
    <!-- 加入分销商品导入成功 -->
    <JoinResultDialog ref="joinResultDialog" :type="type"/>
    <!-- 平台资料额度弹窗 -->
    <QuotaDialog
      :visible.sync="quotaDialog.visible"
      :total="quotaDialog.total"
      :used="quotaDialog.used"
      @subscribe="goSubscribe"
      @clean-duplicate="cleanDuplicate"
      @clean-low-sales="cleanLowSales"
    />
    <!-- 低销量检测弹窗 -->
    <LowSalesDialog
      :visible.sync="lowSalesDialog.visible"
      :resultCount="lowSalesDialog.resultCount"
      @scan="onLowSalesScan"
      @view="onLowSalesView"
      @delete="onLowSalesDelete"
    />
    <!-- 重复商品清理抽屉 -->
    <DuplicateCleanDrawer
      :visible.sync="duplicateCleanDrawer.visible"
      :groups="duplicateCleanDrawer.groups"
      :defaultTab="duplicateCleanDrawer.activeTab"
    />
  </div>
</template>

<script>
import ErrorInfo from './components/ErrorInfo.vue'
import SupplierInfo from "./components/supplierInfo.vue";
import Search from "./components/search.vue";
import Sorter from "./components/Sorter.vue";
import GoodsFilter from "./components/GoodsFilter.vue";
import GoodsList from "./components/GoodsList.vue";
import BulkShelvesDialog from "@/components/prod/center/dialogs/bulkShelvesDialog.vue";
import BulkShelvesResults from "@/components/prod/center/dialogs/bulkShelvesResults.vue";
import GroupBulkShelvesDialog from "@/components/prod/center/dialogs/GroupBulkShelvesDialog/index.vue";
import ImportSupplierItem from "@/components/prod/center/dialogs/importSupplierItem.vue";
import EditDialog from "@/components/prod/center/dialogs/EditDialog.vue";
import DownloadProgress from "@/components/prod/center/components/DownloadProgress.vue";
import DownloadResult from "@/components/prod/center/components/DownloadResult.vue";
import CheckboxOuterId from "@/components/prod/center/dialogs/checkOuterId2.vue"
import JoinResultDialog  from '@/components/prod/center/dialogs/joinResultDialog.vue'
import { prodSupplierGoodsList, getCheckDistributionOuterId, getPriceAndStockAlone } from "@servers/prod/center";
import { importSupplierItem } from "@api/distributor";
import { mapGetters, mapActions } from "vuex";
import { cloneDeep, get } from "lodash";
import { getCooperationRelation, supplierPromotionShopCompanyInfo, tryAutoCreateDistributor } from '@/api/distributor';
import { relationBind, queryCartInfo } from '@/api/supplier';
import { DEFAULT_AMOUNT_DIGIT } from '@/dictionary/index.js';
import shoppingCartImg from '@/assets/images/index/shoping_cart_icon.png';
import QuotaDialog from '@/components/prod/center/QuotaDialog.vue';
import LowSalesDialog from '@/components/prod/center/LowSalesDialog.vue';
import DuplicateCleanDrawer from '@/components/prod/center/dialogs/DuplicateCleanDrawer.vue';

export default {
  props: {
    supplierCompanyId: [Number, String],
    hideGoodsList: {
      default: false,
      type: Boolean,
    },
    showWarning: {
      default: true,
      type: Boolean,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    amountPrecision: {
      type: Number,
      default: DEFAULT_AMOUNT_DIGIT,
    },
  },
  provide: {
    publishEntrance: 2,
    pageId: 'd_display'
  },
  components: {
    ErrorInfo,
    SupplierInfo,
    Search,
    Sorter,
    GoodsFilter,
    GoodsList,
    BulkShelvesDialog,
    GroupBulkShelvesDialog,
    ImportSupplierItem,
    DownloadProgress,
    DownloadResult,
    EditDialog,
    BulkShelvesResults,
    CheckboxOuterId,
    JoinResultDialog,
    QuotaDialog,
    LowSalesDialog,
    DuplicateCleanDrawer
  },
  data() {
    return {
      shoppingCartImg,
      loading: false,
      pagination: {
        pageNo: 1,
        pageSize: 20,
        total: 0,
      },
      list: [],
      progressTitle: "商品正在导入中...",
      taskTypeEnum: "",
      resultVisible: false,
      resultData: {},
      isJoin: false,
      // 选中的商品数组
      selectedGoods: [],
      // 本页全选
      allSelected: false,
      // 是否合作中关系 0 - 未建立合作关系 1-待审核 11-待审核 12-待授权 2-已生效 3-已作废 4-已拒绝
      isInCooperation: 0,
      supplierInfo: {},
      filterParams: {
        newPutTime: null,
        displayCode:[],
      },
      type: '',
      autoSuccess: false,
      cartNumber: 0,
      quotaDialog: { visible: false, total: 0, used: 0 },
      lowSalesDialog: { visible: false, resultCount: 0 },
      duplicateCleanDrawer: { visible: false, groups: [], activeTab: 'merge' },
    };
  },
  computed: {
    ...mapGetters([
      "userInfo",
      "speedResult",
      "speedPercentage",
      "routerPrefix",
      "displayRePublishData",
      "platformItemLimit",
      "publishedTotalCount",
    ]),
    ...mapGetters({
      baseItemCount: "platformBaseItemCount",
      platformLimitLoaded: "platformQuotaLoaded",
      publishItemLimit: "publishItemLimit",
    }),
    publishResult() {
      return this.speedResult("d_display");
    },
    publishPercenttage() {
      return this.speedPercentage("d_display");
    },
  },
  watch: {
    supplierCompanyId(newVal, oldValue) {
      if (!newVal && this.showWarning) {
        this.$message.warning('请先选择供销商');
        return;
      }
      this.getIsInCooperation();
      this.getSupplierInfo(newVal);
      if (!this.hideGoodsList) {
        // 供销商的商品详情里不需要调这些接口
        this.pagination.pageNo = 1;
        this.fetchList();
        let selectedGoods = this.$refs.goodList.method_getSelectedArr();
        this.selectedGoods = selectedGoods;
      }
    },
    allSelected(newValue, oldValue) {
      // allSelectedSingle 如果是列表单选false，导致全选的勾选false，不要全部勾选false掉
      let allSelectedSingle = sessionStorage.getItem('allSelectedSingle') || false;
      // 本页全选
      let list = cloneDeep(this.list);
      if(!allSelectedSingle || allSelectedSingle=='false'){
        list.forEach(item => {
          item.ischecked = newValue;
        });

        this.selectedGoods = newValue ? cloneDeep(list) : [];
        this.$refs.goodList.selectedArr = newValue ? cloneDeep(list) : [];
      }
      
      this.list = list;
      
      
      sessionStorage.setItem('allSelectedSingle', false);
    }
  },
  methods: {
    ...mapActions(["clearDisplayRePublishRowData", "fetchPlatformQuota"]),
    shouldBlockAddGoodsByQuota() {
      if (!this.platformLimitLoaded) return false;
      if (this.platformItemLimit === null) return false;
      if (this.platformItemLimit === undefined) return false;
      const limit = Number(this.platformItemLimit);
      if (!isFinite(limit)) return false;
      const used = Number(this.baseItemCount) || 0;
      return used >= limit;
    },
    openQuotaDialogIfBlocked() {
      if (!this.shouldBlockAddGoodsByQuota()) return false;
      const limit = this.platformItemLimit;
      if (limit === null) return false;
      if (limit !== undefined) {
        this.quotaDialog.total = limit;
        this.quotaDialog.used = typeof this.baseItemCount === 'number' ? this.baseItemCount : 0;
      } else {
        this.quotaDialog.total = this.quotaDialog.total || 0;
        this.quotaDialog.used = this.quotaDialog.used || 0;
      }
      this.quotaDialog.visible = true;
      return true;
    },
    openQuotaDialog() {
      this.quotaDialog.visible = true;
      this.initQuotaInfo();
    },
    async initQuotaInfo() {
      if (!this.platformLimitLoaded) {
        await this.fetchPlatformQuota();
      }
      const limit = this.platformItemLimit;
      if (limit === null) {
        this.quotaDialog.total = '无上限';
        this.quotaDialog.used = typeof this.baseItemCount === 'number' ? this.baseItemCount : 0;
        return;
      }
      if (limit !== undefined) {
        this.quotaDialog.total = limit;
        this.quotaDialog.used = typeof this.baseItemCount === 'number' ? this.baseItemCount : 0;
        return;
      }
      this.quotaDialog.total = this.quotaDialog.total || 0;
      this.quotaDialog.used = this.quotaDialog.used || 0;
    },
    goSubscribe() {
      this.$message.warning('订购平台资料加量包，请联系销售人员');
    },
    cleanDuplicate() {
      this.quotaDialog.visible = false;
      this.duplicateCleanDrawer.visible = true;
    },
    cleanLowSales() {
      this.quotaDialog.visible = false;
      this.lowSalesDialog.visible = true;
    },
    onLowSalesScan(payload) {
      this.$message.info(`已发起扫描：创建时间>${payload.createDays}天，${payload.salesDays}天内销量≤${payload.salesThreshold}`);
      this.lowSalesDialog.resultCount = 0;
    },
    onLowSalesView() {
      this.$message.success('即将跳转商品中心-平台资料查询（待接入）');
    },
    onLowSalesDelete() {
      if (this.lowSalesDialog.resultCount === 0) {
        this.$message.warning('暂无可删除的低销量商品');
        return;
      }
      this.$confirm('确认删除已扫描的低销量商品？此操作不可撤销。', '提示', { type: 'warning' })
        .then(() => {
          this.lowSalesDialog.resultCount = 0;
          this.$message.success('已删除低销量商品（占位）');
        })
        .catch(() => {});
    },
    progressClose() {
      if (this.autoSuccess) {
        this.$emit('needRefresh')
      }
    },
    toShoppingCart() {
      this.$router.push({
        path:`/distributor/supplier/shoppingCart`,
        query:{
          supplierCompanyId: this.supplierCompanyId
        }
      });
    },
    search() {
      this.pagination.pageNo = 1;
      this.fetchList();
    },
    // 更新选中商品数组
    updateSelectedGoods(arr, currentCheck) {
      this.selectedGoods = arr;
      // 是否全选本页
      this.allSelected = arr.length === this.list.length;

      // 单个选择的时候，false，全选会变成false，全选变成false的同时，不要全部勾选false掉
      if (!currentCheck) {
        sessionStorage.setItem('allSelectedSingle', true);
      }
    },

    // 更新筛选参数
    updateFilterParams(params) {
      this.filterParams = params;
    },

    async getSupplierInfo(id) {
      let res = await supplierPromotionShopCompanyInfo({
        supplierCompanyId: id,
      });
      let detail = get(res, 'data', {}) || {};
      this.supplierInfo = detail;
    },

    // 是否合作中的供销商
    async getIsInCooperation() {
      const res = await getCooperationRelation({
        distributorCompanyId: this.userInfo.companyId,
        supplierCompanyId: this.supplierCompanyId,
      });
      // 0-未建立合作关系、1-待审核、2-已合作、3-已停止、4-已拒绝
      this.isInCooperation = get(res, 'data', 0);
    },

    topBtnsClick() {
      if (this.isInCooperation !== 2) {
        this.showCooperationDialog('shelves', true);
        return;
      }
      // 一些需要判断是否需要先选择商品
      const selectedRows = this.$refs.goodList.method_getSelectedArr();
      if (!selectedRows.length) return this.$message.warning("请先选择商品");
      // 取铺货平台的交集
      const _canPublishPlatforms = selectedRows.map(row => {
        return row.canPublishPlatform;
      });
      const canPublishPlatform = _canPublishPlatforms.reduce((data, item) => {
        return data.filter(i => {
          return item.some(j => {
            return i === j;
          });
        });
      });
      if (canPublishPlatform.length) {
        if (canPublishPlatform.length === 1 && canPublishPlatform[0] === "tm") {
          this.$message.warning("天猫平台暂不支持批量铺货操作");
        } else {
          this.$refs.bulkShelvesDialog.method_open("multi", selectedRows, {
            isDistributor: true,
            canPublishPlatform,
            publishType: "PUBLISH_ITEM",
            publishEntrance: 2,
          });
        }
      } else {
        const isFalg = selectedRows.some(row => {
          return row.canPublishPlatform.length;
        });
        if (selectedRows.length === 1) {
          return this.$message.warning("暂无可铺货平台");
        } else {
          if (isFalg) {
            return this.$message.warning(
              "商品可铺货平台不一致，仅支持同平台铺货"
            );
          } else {
            return this.$message.warning("暂无可铺货平台");
          }
        }
      }
    },

    // 组合铺货
    groupBulkShelves() {
      if (this.isInCooperation !== 2) {
        this.showCooperationDialog('group');
        return;
      }
      const selectedRows = this.$refs.goodList.method_getSelectedArr();
      selectedRows.forEach(item => {
        item.mainImagesTrim = item.mainImages;
      });
      if (selectedRows.length < 2) {
        return this.$message.warning("单个商品不支持组合铺货！");
      } else if (selectedRows.length > 50) {
        return this.$message.warning("组合铺货商品数量不能超过50个！");
      }
      this.$refs.groupBulkShelvesDialog.method_open(selectedRows);
    },

    // 分页改变
    handleSizeChange(val) {
      this.pagination.pageNo = 1;
      this.pagination.pageSize = val;
      this.allSelected = false;
      this.fetchList();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.allSelected = false;
      this.fetchList();
    },
    openEditDialog(params, extraParams) {
      if(params.distributionBaseItemIds?.length) {
        params.baseItemId = params.distributionBaseItemIds[0]
      }
      this.$refs.editDialog.method_open(params, extraParams);
    },
    closeEditDialog() {
      this.$refs.editDialog.method_close();
    },

    // 加入分销之前，需要判断加入分销商品款式编码是否已经存在
    async fetch_checkDistributionOuterId(params) {
       const res  = await getCheckDistributionOuterId(params);
       return res
    },
    // 批量加分销
    async batchAddDistribution() {
      if (this.isInCooperation !== 2) {
        this.showCooperationDialog('join', true);
        return;
      }
      let selectedGoods = this.$refs.goodList.method_getSelectedArr();
      const supplierItemList = selectedGoods.map(row => {
        let o = {
          supplierCompanyId: row.companyId,
          baseItemId: row.baseItemId,
        };
        if (row.isHaveNewDisSku) {
          o.addDistributorSku = true
        }
        return o;
      })
      const baseItemIds = selectedGoods.map(row => {
        return row.baseItemId
      })

      const checkRes = await this.fetch_checkDistributionOuterId({
        baseItemIds:baseItemIds,
        companyId: this.supplierCompanyId
      });
      const params = {
          supplierItemList,
          syncType: 1,
          inputType: 5,
        };
      this.taskTypeEnum = "JOIN_DISTRIBUTOR_ITEM";
      if (checkRes.repeat) {
        // 有重复的 弹提示弹窗
        this.$refs.checkboxOuterId.method_open(params, checkRes);
      } else {
        this.progressTitle = `${selectedGoods.length}款商品正在加入中...`;
        this.fetch_importSupplierItem(params,'batchJoinGoods');
      }
    },
    /**
     * 展示是否合作弹窗
     * isBatch - 是否批量 0：否，1：是
     */
    showCooperationDialog(type, isBatch) {
      let arr = [3, 1, 2, 3, 3];
      arr[11] = 1;
      arr[12] = 12;
      let num = isBatch ? 0 : arr[this.isInCooperation];
      let key = `${type}${isBatch ? 'Batch' : ''}${num}`;
      if (type === 'group') {
        key = 'group';
      }
      // 去审核
      const goAudit = () => {
        this.$router.push({
          path: '/distributor/supplier/mine',
          query: {
            searchContent: this.supplierInfo.companyName,
          },
        });
      }

      const handleRelationBind = async () => {
        const { companyId: distributorCompanyId } = this.userInfo;
        let supplierCompanyId = get(this.$route, 'query.supplierId', '');
        let res = await relationBind({
          distributorCompanyId,
          needAudit: 1,
          supplierCompanyId,
        })
        if (res.result === 1) {
          this.$message.success('已提交申请')
        }
      }
      const messageMap = {
        // 加入分销商品（待审核）
        join1: {
          message: '您还没同供销商建立供分销关系，需合作后才能加分销商品到您的分销商品库，请先审核该供销商的合作申请',
          confirmButtonText: '去审核',
          cancelButtonText: '稍后再说',
          onConfirm: goAudit,
        },
        // 加入分销商品（待授权）
        join12: {
          message: '您已提交合作申请，需合作后才能加分销商品到您的分销商品库，请耐心等待哦~',
          confirmButtonText: '我知道了',
          showCancelButton: false,
        },
        // 加入分销商品（已拒绝、已停止）
        join3: {
          message: '您还没同供销商建立供分销关系，需合作后才能加分销商品到您的分销商品库，请先提交合作申请',
          confirmButtonText: '立即申请',
          cancelButtonText: '稍后再说',
          onConfirm: handleRelationBind,
        },
        // 一键铺货（待审核）
        shelves1: {
          message: '您还没同供销商建立供分销关系，需合作后才能把商品一键铺货到您的店铺，请先审核该供销商的合作申请',
          confirmButtonText: '去审核',
          cancelButtonText: '稍后再说',
          onConfirm: goAudit,
        },
        // 一键铺货（待授权）
        shelves12: {
          message: '您已提交合作申请，需合作后才能把商品一键铺货到您的店铺，请耐心等待哦~',
          confirmButtonText: '我知道了',
          showCancelButton: false,
        },
        // 一键铺货（已拒绝、已停止）
        shelves3: {
          message: '您还没和供销商建立供分销关系，需合作后才能把商品一键铺货到您的店铺，请先提交合作申请',
          confirmButtonText: '立即申请',
          cancelButtonText: '稍后再说',
          onConfirm: handleRelationBind,
        },
        // 批量加入分销（未合作）
        joinBatch0: {
          message: '您还没同供销商建立供分销关系，无法批量加入分销商品，需向商家申请并建立合作关系后再来操作~',
          confirmButtonText: '取消加入分销',
          showCancelButton: false,
        },
        // 批量铺货（未合作）
        shelvesBatch0: {
          message: '您还没同供销商建立供分销关系，若要全部铺货到指定平台，需向商家申请并建立合作关系后再来操作~',
          confirmButtonText: '取消批量铺货',
          showCancelButton: false,
        },

        // 组合铺货（未合作）
        group: {
          message: '您还没同供销商建立供分销关系，若要全部铺货到指定平台，需向商家申请并建立合作关系后再来操作~',
          confirmButtonText: '取消组合铺货',
          showCancelButton: false,
        },
      }
      const confirmConfig = {
        title: '提示',
        message: '您还没和供销商建立供分销关系，需合作后才能把商品一键铺货到您的店铺，请先提交合作申请',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      };
      this.$confirm(confirmConfig.title, messageMap[key]?.message, {
        ...confirmConfig,
        ...messageMap[key],
        callback: (action, instance) => {
          if (action === 'confirm') {
            if (messageMap[key]?.onConfirm) {
              messageMap[key].onConfirm();
            }
          } else {
            console.log('弹窗关闭');
          }
        }
      })
    },
    async tryAutoCreateDistributorEvent(id) {
      const res = await tryAutoCreateDistributor({
        distributorCompanyId: this.$store.getters.userInfo.companyId,
        supplierCompanyId: id
      });
      const createDistributor = get(res, 'data.createDistributor', false);
      return createDistributor
    },
    // 加入分销，一键铺货，更新分销商品
    async rowClick(type, row) {
      if (this.isInCooperation !== 2) {
        if (type === 'join') {
          this.autoSuccess = await this.tryAutoCreateDistributorEvent(row.companyId);
        }
        
        if (!this.autoSuccess) {
          this.showCooperationDialog(type);
          return;
        }
      }
      switch (type) {
        case "update": // 更新分销商品
          /**
           * isHaveNewDisSku ture 表示，供销商有新增的sku 但是分销商还没加分销进来，要先加分销商品
           * isHaveNewDisSku true 不让过， false 让过
           */
          if (!row.isDistributor || row.isHaveNewDisSku) {
            return this.$message.warning('请先加分销商品')
          }
          let update_params = {
            supplierItemList: [
              {
                supplierCompanyId: row.companyId,
                baseItemId: row.baseItemId,
              },
            ],
            syncType: 2,
            inputType: 5,
          }
          this.taskTypeEnum = "UPDATE_DISTRIBUTOR_ITEM";
          this.progressTitle = "商品正在更新中...";
          this.fetch_importSupplierItem(update_params);

          break;
        case "join": // 加入分销
          this.joinItemToShop(row, type);
          break;
        case "shelves": // 铺货
          if (row.canPublishPlatform.length && row.canPublishPlatform[0] === "tm") {
            this.$message.warning(
              "需将商品导入商品资料并前往商品资料才可进行天猫铺货"
            );
          } else {
            // 一键铺货，若商品已加入分销，进入铺货环节，若商品未加入分销，自动加入分销商品
            if (!row.isDistributor || row.isHaveNewDisSku) {
              this.joinItemToShop(row, type);
            }else{
              this.$refs.bulkShelvesDialog.method_open("single", [row], {
                  isDistributor: true,
                  canPublishPlatform: row.canPublishPlatform,
                  publishType: "PUBLISH_ITEM",
                  publishEntrance: 2,
              });
            }
          }
          break;
        default:
      }
    },
    async joinItemToShop(row, type){
      if (!this.platformLimitLoaded) {
        await this.fetchPlatformQuota();
      }
      if (this.openQuotaDialogIfBlocked()) return;
      if (row.isDistributor && !row.isHaveNewDisSku) {
        this.$message.warning('该商品已在分销商品中');
        return;
      }
      const params = {
        supplierItemList: [
          {
            supplierCompanyId: row.companyId,
            baseItemId: row.baseItemId,
          },
        ],
        syncType: 1,
        inputType: 5,
      };
      if (row.isHaveNewDisSku) {
        // 部分sku更新，请求参数需要加入addDistributorSku字段
        params.supplierItemList = params.supplierItemList.map(item => {
          return {
            ...item,
            addDistributorSku: true
          }
        })
      }
      // 校验编码是否重复
      const checkRes = await this.fetch_checkDistributionOuterId({
        baseItemIds:[row.baseItemId],
        companyId: this.supplierCompanyId
      });

      this.taskTypeEnum = "JOIN_DISTRIBUTOR_ITEM";
      if (checkRes.repeat) {
        // 有重复的 弹提示弹窗
        this.$refs.checkboxOuterId.method_open(params, checkRes, row, type);
      } else {
        this.progressTitle = "商品正在加入中...";
        this.fetch_importSupplierItem(params, 'singleJoinGoods', row, type);
      }
    },

    async fetchList() {
      this.$refs.goodList.methods_clearSelectedArr();
      this.allSelected = false;
      const { pageNo, pageSize } = this.pagination;
      const searchParams = this.$refs.search.method_getSearchForm();
      const sortParams = this.$refs.sorter.getSortParams();
      const filterParams = this.$refs.goodsFilter.getFilterParams();
      this.loading = true;
      let ifFillStock = true,ifFillFxPrice = true;
      if(this.isInCooperation === 2){
        ifFillStock = false;
        ifFillFxPrice = false;
      }
      const _params = {
        companyId: this.supplierCompanyId,
        pageNo,
        pageSize,
        ...searchParams,
        ...sortParams,
        ...filterParams,
        ifReturnSkus: false,
        // 对查询接口做优化，已合作的情况，不在查询库存和分销价。库存和分销价通过异步加载获取
        ifFillStock,
        ifFillFxPrice,
        ifFillCommissionPrice:false,
        ifFillFreightRule:true,
      };
      const res = await prodSupplierGoodsList(_params);

      // 如果是已合作的情况才异步请求分销价和库存
      if(this.isInCooperation === 2){
        // 分销价和库存异步加载
        const baseItemIds = res.records.map(item => item.baseItemId);
        if(baseItemIds.length){
          let priceParams={
            supplierCompanyId: this.supplierCompanyId,
            distributorCompanyId: this.userInfo.companyId,
            baseItemIds
          }
          const prices = await getPriceAndStockAlone(priceParams);
          // 查询到分销价后，然后反哺到列表
          res.records.forEach(item => {
            const priceItem = prices.find(price => price.baseItemId === item.baseItemId);
            if (priceItem) {
              item.levelDistributionPrice = priceItem.levelDistributionPrice;
              item.commissionPrice = priceItem.commissionPrice;
              item.commissionScale = priceItem.commissionScale;
            }
          });
        }
      }
      
      
      

      this.loading = false;
      if (res) {
        const { records, total } = res;
        const _records = records.map(item => {
          return {
            ...item,
            ischecked: false,
          };
        });
        this.list = _records;
        this.pagination.total = total;
        //  重新铺货
        if (
          this.displayRePublishData &&
          this.displayRePublishData.publishEntrance == 2
        ) {
          let _displayRePublishData = {
            ...this.displayRePublishData
          }
          this.clearDisplayRePublishRowData();
          const canPublishPlatform =
            _displayRePublishData.platform.split(",");
          if (canPublishPlatform.length) {
            if (
              canPublishPlatform.length === 1 &&
              canPublishPlatform[0] === "tm"
            ) {
              this.$message.warning(
                "需将商品导入商品资料并前往商品资料才可进行天猫铺货"
              );
            } else {
              this.$refs.bulkShelvesDialog.method_open(
                "single",
                [
                  {
                    ..._displayRePublishData,
                    canPublishPlatform,
                    companyId: _displayRePublishData.extendVal2,
                  },
                ],
                {
                  isDistributor: true,
                  canPublishPlatform,
                  publishType: "PUBLISH_ITEM",
                  publishEntrance: 2,
                }
              );
            }
          } else {
            this.$message.warning("暂无可铺货平台");
          }
        }
      }
    },

    // 加入分销商品
    async fetch_importSupplierItem(params, type, row, shelvesType) {
      this.type = type;
      const _params = {
        ...params
      };
      const { supplierItemList, syncType } = params;
      const res = await importSupplierItem(_params);
      if (res.result === 1) {
        // 轮询查看同步任务结果
        this.isJoin = ["UPDATE_DISTRIBUTOR_ITEM"].includes(this.taskTypeEnum) ? false : true;
        this.$refs.progressDialog.showDialog();
        this.$refs.progressDialog.fetch_joinDistributorItemResult(
          { taskTypeEnum: this.taskTypeEnum },
          res => {
            if (res.finished) {
              if (["JOIN_DISTRIBUTOR_ITEM", "UPDATE_DISTRIBUTOR_ITEM"].includes(this.taskTypeEnum)) {
                if (syncType === 2) {
                  // 更新分销商品
                  if (res.result?.failureNum || res.result?.failNum || res.result?.partSuccessNum) {
                     // 后端这边确认失败字段为failNum。这里做一层兼容。失败组件取值是failureNum和errorMsg
                     if(res.result.failNum && !res.result.failureNum){
                      res.result.failureNum = res.result.failNum;
                      res.result.errorMsg = res.result.failMessage;
                    }

                    this.$refs.errorInfo.method_open(res.result, true);
                  } else {
                    if(shelvesType === 'shelves'){
                      row.distributionBaseItemIds = res.result.distributionBaseItemIds;
                      this.$refs.bulkShelvesDialog.method_open("single", [row], {
                        isDistributor: true,
                        canPublishPlatform: row.canPublishPlatform,
                        publishType: "PUBLISH_ITEM",
                        publishEntrance: 2,
                      });
                    }else{
                      this.$message.success('更新分销商品成功')
                    }
                  }
                  this.fetchList();
                } else {
                  // 加入分销商品
                  // 先检查是否业务失败（failureNum 或 failNum）
                  const failureNum = res.result?.failureNum || res.result?.failNum || 0;
                  const errorMsg = res.result?.errorMsg || res.result?.failMessage || '';

                  if (failureNum > 0 && shelvesType === 'shelves') {
                    // 加入失败：关闭进度弹窗，展示真实errorMsg，不打开铺货弹窗
                    this.$refs.progressDialog.handleClose();
                    this.$message.error(errorMsg || '商品加入分销小店失败');
                    this.fetchList();
                    return;
                  }

                  if(shelvesType === 'shelves'){
                    row.distributionBaseItemIds = res.result.distributionBaseItemIds;
                    this.$refs.bulkShelvesDialog.method_open("single", [row], {
                      isDistributor: true,
                      canPublishPlatform: row.canPublishPlatform,
                      publishType: "PUBLISH_ITEM",
                      publishEntrance: 2,
                    });
                  }
                  else{
                    this.$refs.errorInfo.method_open(res.result);
                  }
                  !res.errorMsg && this.fetchList();
                }
              } else {
                this.resultData = _.assign(this.resultData, res.result);
                this.resultVisible = true;
              }
            }
          }
        );
      }
    },

    // 解析购物车数据，获取总数
    parseShoppingCartNum(list) {
      let num = 0;
      (list || []).forEach(item => {
        if (item.pureType) {
          num += Number((item.pureTypeData?.num || 0));
        } else {
          item.skuList.forEach(sku => {
            num += Number((sku.num || 0));
          });
        }
      });
      return num;
    }
  },
  async mounted() {
    if (!this.supplierCompanyId) {
      if (this.showWarning) {
        this.$message.warning('请先选择供销商');
      }
      return;
    }
    await this.getIsInCooperation();
    this.getSupplierInfo(this.supplierCompanyId);
    if (!this.hideGoodsList) {
      this.fetchList();
      let selectedGoods = this.$refs.goodList.method_getSelectedArr();
      this.selectedGoods = selectedGoods;
      
      // 获取采购车数量
      this.supplierCompanyId && queryCartInfo({supplierCompanyId: this.supplierCompanyId}).then(res => {
        let total = this.parseShoppingCartNum(res.data.records);
        this.cartNumber = total > 99 ? '99+' : total;
      });
    }
  },
  beforeDestroy() {
    this.clearDisplayRePublishRowData();
  },
  deactivated() {
    this.$refs.progressDialog.handleClose();
  },
};
</script>

<style lang="scss" scoped>
.display-goods-list {
  margin-top: 16px;
  text-align: left;
  box-sizing: border-box;
  background: #ffffff;
  padding: 20px;
}
.down-title {
  font-size: 18px;
  padding-bottom: 20px;
  display: inline-block;
  font-weight: 800;
}
.table-btns-wrap {
  margin-bottom: 16px;
  margin-top: 8px;
  display: flex;
  align-items: center;
}
.sticky {
  position: sticky;
  top: 0;
  padding: 12px;
  background-color: #fff;
  z-index: 99;
  // box-shadow: 0px 10px 20px 0px rgba(126, 125, 125, 0.2);
  border-bottom: 1px solid #EBEEF5;
}
.shop-cart{
  position: fixed;
  bottom: 100px;
  right: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 80px;
  height: 80px;
  border-radius: 80px;
  background: #fff;
  border: 1px solid #DFDFDF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);
  .image-cart{
    width: 30px;
  }
  .num{
    background: red;
    border-radius: 10px;
    padding: 0px 6px;
    color:#fff;
    position: absolute;
    top: 4px;
    right: 10px;
    font-size: 12px;
    font-weight: bold;
  }
  .text{
    font-size: 12px;
    color:#333;
  }
}
</style>
